const schedules = [
  {
    date: "2026年4月",
    status: "受付中",
    location: "旭川市旭川駅前広場",
    address: "北海道旭川市宮下通7丁目（旭川駅前広場）",
    note: "旭川駅直結のアクセス抜群の会場。専門スタッフが丁寧にご相談をお受けします。",
    mapUrl: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2935.4940382817!2d142.3648!3d43.7707!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x5f0af89a4de6f8a1%3A0x3b5a1c3e7a6b9f0a!2z5peX5bed6amX5YmN5YmN5YmN6aeF5pa5!5e0!3m2!1sja!2sjp!4v1710000000000",
  },
];

export default function ConsultationSection() {
  return (
    <section id="consultation" className="py-24 bg-white">
      <div className="max-w-5xl mx-auto px-6">
        {/* Heading */}
        <div className="text-center mb-16">
          <span className="inline-block text-teal-700 text-sm font-semibold tracking-widest uppercase mb-3">Upcoming Event</span>
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4" style={{ fontFamily: "'Noto Serif JP', serif" }}>
            出張相談会のご案内
          </h2>
          <div className="w-12 h-0.5 bg-amber-500 mx-auto mb-6" />
          <p className="text-gray-600 text-base max-w-xl mx-auto">
            2026年4月より、旭川でも出張相談会を開催。<br />
            札幌まで行かなくても専門スタッフにご相談いただけます。
          </p>
        </div>

        {/* Event card */}
        {schedules.map((s) => (
          <div key={s.date} className="rounded-xl border border-teal-100 bg-teal-50 overflow-hidden">
            <div className="grid md:grid-cols-2">
              {/* Info */}
              <div className="p-8 md:p-10">
                <div className="flex items-center gap-3 mb-6">
                  <span className="inline-flex items-center gap-1.5 bg-teal-700 text-white text-xs font-bold px-3 py-1.5 rounded-full">
                    <i className="ri-calendar-event-line" />
                    {s.date}
                  </span>
                  <span className="inline-flex items-center gap-1.5 bg-amber-500 text-white text-xs font-bold px-3 py-1.5 rounded-full">
                    <i className="ri-radio-button-line" />
                    {s.status}
                  </span>
                </div>

                <h3 className="text-2xl font-bold text-gray-900 mb-3" style={{ fontFamily: "'Noto Serif JP', serif" }}>
                  {s.location}
                </h3>
                <div className="flex items-start gap-2 text-sm text-gray-600 mb-4">
                  <i className="ri-map-pin-line text-teal-600 mt-0.5 flex-shrink-0" />
                  <span>{s.address}</span>
                </div>
                <p className="text-gray-600 text-sm leading-7 mb-6">{s.note}</p>

                <ul className="space-y-2 text-sm text-gray-600 mb-8">
                  <li className="flex items-center gap-2">
                    <i className="ri-check-double-line text-teal-600" />
                    無料相談・入れ歯に関するご質問OK
                  </li>
                  <li className="flex items-center gap-2">
                    <i className="ri-check-double-line text-teal-600" />
                    札幌クリニックへの申込みもその場で可能
                  </li>
                  <li className="flex items-center gap-2">
                    <i className="ri-check-double-line text-teal-600" />
                    予約不要（当日直接お越しください）
                  </li>
                </ul>

                <a
                  href="https://pro.form-mailer.jp/fms/e40aa43b232020"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="whitespace-nowrap cursor-pointer inline-flex items-center gap-2 bg-teal-700 hover:bg-teal-800 text-white font-semibold text-sm px-6 py-3 rounded-md transition-colors"
                >
                  <i className="ri-calendar-2-line" />
                  相談会に申し込む
                </a>
              </div>

              {/* Image */}
              <div className="h-64 md:h-auto w-full">
                <img
                  src="https://static.readdy.ai/image/90b8495d3de38d7de3b4d3abd2a2907e/385349c8ed6ed0ea85a12996ef7c74a8.jpeg"
                  alt="旭川駅前広場"
                  className="w-full h-full object-cover object-top"
                />
              </div>
            </div>
          </div>
        ))}

        {/* Notice */}
        <div className="mt-8 bg-amber-50 border border-amber-200 rounded-lg px-6 py-4 text-sm text-amber-800">
          <i className="ri-information-line mr-2" />
          今後の開催スケジュールは随時更新いたします。詳細はお問い合わせください。
        </div>
      </div>
    </section>
  );
}
